/* eslint-disable @typescript-eslint/naming-convention */
import { logWarning } from 'shared-code/log'
import { DSInitOptions, QueryType } from 'shared-definitions/types'

export type RequestBody = Record<string, string | number>

interface RequesterOpts extends DSInitOptions {
  csrfTokenGetter: () => Promise<string>
  linkBuilder: (endpoint: string, query: QueryType) => string
}

class Requester {
  private readonly opts

  constructor(opts: RequesterOpts) {
    this.opts = opts
  }

  async makeRequest(endpoint: string, query: QueryType = {}): Promise<any> {
    const link = this.opts.linkBuilder(encodeURI(endpoint), {
      ...query,
      ...(this.opts.ts ? { ts: this.opts.ts } : {}),
      ...(this.opts.previewToken
        ? {
            preview_token: this.opts.previewToken,
            request_ts: Date.now(),
          }
        : {}),
      // request_ts: Date.now(), // to bypass caching
    })
    const response = await fetch(link)
    const text = await response.text()
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return JSON.parse(text)
    } catch (e) {
      logWarning(
        'Wp response json body parse error. Endpoint: ',
        endpoint,
        'Incoming content: ',
        text
      )
      throw e
    }
  }

  async makeSubmitJson(endpoint: string, body: RequestBody): Promise<any> {
    const response = await fetch(this.opts.linkBuilder(encodeURI(endpoint), {}), {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      redirect: 'follow',
      headers: {
        'Content-Type': 'application/json',
      },
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({
        ...body,
        _wpnonce: await this.opts.csrfTokenGetter(),
      }),
    })
    return response.json()
  }
}

export default Requester
